var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.808,
    height: 24.641,
    viewBox: "0 0 27.808 24.641",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000038385227688418196620000001652529180024542354_",
    transform: "translate(0.018 -29.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Social_Icon",
    transform: "translate(-0.018 29.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PaperPlane",
    d: "M2.791,29.2A2.806,2.806,0,0,0,.309,33.311l3.6,6.821,12.062,1.385L3.9,42.908l-3.6,6.821a2.808,2.808,0,0,0,3.6,3.883L26.161,44a2.7,2.7,0,0,0,0-4.959L3.9,29.428A2.817,2.817,0,0,0,2.791,29.2Z",
    transform: "translate(0.018 -29.2)",
    fill: "#41a5ee"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessageIcon);
export default __webpack_public_path__ + "static/media/sendMessageIcon.cb342f0e7dd71ff4edfbed2c7cf5323c.svg";
export { ForwardRef as ReactComponent };